import { apiErrorsEn } from './apiErrors'

export default {
  apiErrors: apiErrorsEn,
  common: {
    required: "This field is required",
    confirmTitle: "System Tip",
    reminder: 'tip',
    loginOutMessage: 'Are you sure you want to log out?',
    back: 'Back',
    ok: 'Confirm',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    deleteUserConfirm: 'Are you sure you want to delete user "{userName}"? This operation cannot be undone.',
    deleteUserTitle: 'Delete Confirmation',
    thisUser: 'this user',
    deleteSuccess: 'Delete success',
    deleteFailed: 'Delete failed',
    firmwareDeleteApprovalSubmitted: 'Delete request submitted successfully. The firmware will be deleted after approval.',
    next: 'Next',
    decline: 'Decline'
  },
  sys: {
    api: {
      errMsg500: "Internal Server Error",
      errMsg901: "Demo mode, write operations are not allowed",
      errMsg901Hint: "Please set up a local environment for write operations.",
      errorMessage: "Network Error",
      apiTimeoutMessage: "API Request Timeout",
      apiRequestFailed: "Request Failed",
      timeoutMessage: "Login status has expired, you can stay on this page, or log in again",
      responseDecryptFailed: "Failed to decrypt response data"
    },
    ui: {
      browserFullscreenUnsupported: "Your browser does not support fullscreen",
      themeResetSuccess: "Theme color has been reset to {color}",
      invalidHex: "Invalid hex value",
      invalidRgb: "Invalid rgb color value",
      invalidHexColor: "Invalid hex color value",
      logoutSuccess: "Logged out successfully"
    }
  },
  home: {
    welcome: "Welcome"
  },
  tabs: {
    refresh: "Refresh",
    maximize: "Maximize",
    closeCurrent: "Close current",
    closeLeft: "Close Left",
    closeRight: "Close Right",
    closeOther: "Close other",
    closeAll: "Close All"
  },
  header: {
    componentSize: "Component size",
    language: "Language",
    theme: "theme",
    layoutConfig: "Layout config",
    primary: "primary",
    darkMode: "Dark Mode",
    greyMode: "Grey mode",
    weakMode: "Weak mode",
    fullScreen: "Full Screen",
    exitFullScreen: "Exit Full Screen",
    personalData: "Personal Data",
    changePassword: "Change Password",
    logout: "Logout",
    version: "Version",
    userName: "User name",
    email: "Email",
    settings: "Settings",
    otherFunction: "Other function",
    role: "Role"
  },
  login: {
    welcome: 'Welcome to the system',
    message: 'Backstage management system',
    tenantname: 'TenantName',
    username: 'Username',
    password: 'Password',
    code: 'verification code',
    login: 'Login',
    relogin: 'Sign in again',
    otherLogin: 'Sign in with',
    register: 'Register',
    checkPassword: 'Confirm password',
    remember: 'Remember me',
    hasUser: 'Existing account? Go to login',
    forgetPassword: 'Forget password?',
    tenantNamePlaceholder: 'Please Enter Tenant Name',
    usernamePlaceholder: 'Please Enter Username',
    passwordPlaceholder: 'Please Enter Password',
    codePlaceholder: 'Please Enter Verification Code',
    mobileTitle: 'Mobile sign in',
    mobileNumber: 'Mobile Number',
    mobileNumberPlaceholder: 'Plaease Enter Mobile Number',
    getSmsCode: 'Get SMS Code',
    btnMobile: 'Mobile sign in',
    btnQRCode: 'QR code sign in',
    qrcode: 'Scan the QR code to log in',
    btnRegister: 'Sign up',
    SmsSendMsg: 'code has been sent',
    resetPassword: "Reset Password",
    resetPasswordSuccess: "Reset Password Success",
    invalidTenantName:"Invalid Tenant Name",
    loadingSystem: "Loading system...",
    containerNotExists: "Container does not exist",
    captchaError: "Verification code error",
    emailExists: "Email already exists",
    sendingCode: "Sending verification code...",
    createId: "Create new ID",
    forgotIdOrPassword: "Forgot ID or Password ?",
    enterUsername: "Please enter user name",
    enterPassword: "Please enter password",
    signIn: "Sign in",
    setupAccount: "Setup Account",
    alreadyHaveAccount: "Already have an account?",
    signInLink: "Sign in",
    emailAddress: "Email address *",
    firstName: "First name *",
    lastName: "Last name *",
    countryRegion: "Country & Region *",
    stateProvince: "State / Province",
    streetAddress: "Street address",
    city: "City",
    zipCode: "Zip / Postal code",
    mobilePhone: "Tele",
    containerId: "Company ID *",
    createPassword: "Password",
    byCreatingAccount: "By clicking Create account, I agree that:",
    termsAgreement: "I have read and accepted the Terms of Use.",
    marketingAgreement: "The V-IoT Software may keep me informed with personalized emails about products and services.",
    privacyAgreement: "See our Privacy Policy for more details or to opt-out at any time.",
    createAccount: "Create an Account",
    verifyAccount: "Verify your Account",
    verifyAccountHint: "We are sending a one-time password to validate your email.",
    afterSeconds: "After {seconds}s",
    resendCode: "Resend the code.",
    accountVerified: "Great! Your account has been verified!",
    termsTitle: "Terms of Use",
    enterEmailAddress: "Enter your email address",
    verifyOwnershipHint: "Answer the following to verify this account is yours.",
    email: "Email",
    recoveryEmail: "Recovery email",
    recoveryEmailHint: "We will send an email containing a one-time verification code to {email}",
    resetPasswordTitle: "Reset Password",
    resetPasswordCodeHint: "Enter the code we sent to your email.",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    enterPasswordPlaceholder: "Enter your password",
    passwordsDoNotMatch: "Passwords do not match",
    changePasswordSummary: "You will change the password for: {email}",
    signOutOtherSessions: "Sign out of all active logins except the current one.",
    changePassword: "Change password",
    backLogin: "Back login",
    resetAction: "Reset",
    resetPasswordSuccessMessage: "The new password had been set sucessfully!",
    sendEmailFailed: "Failed to send email",
    updatePasswordFailed: "Failed to update password",
    emailIncorrectOrNotRegistered: "Email incorrect or does not registry",
    loginFailedGeneric: "Login failed. Please check your email and password.",
    privacyPolicyLink: "Open Privacy Policy",
    privacyPolicyNotConfigured: "Privacy Policy is not configured yet.",
    setupEmailNotRegistered: "This email is not registered for setup.",
    setupEmailAlreadyRegistered: "This email is already registered.",
    setupEmailAvailable: "This email is available.",
    emailRequired: "Email is required",
    invalidEmail: "Invalid email format",
    fieldRequired: "This field is required",
    passwordRequired: "Password is required",
    invalidPassword: "Password must be 4-16 characters long",
    setupPasswordValidation:
      "Password must contain at least one number, one lowercase letter, one uppercase letter, and one special character (e.g. !@#$%^&*()_,.;), and be 8-20 characters long",
    maxCharacters: "Max {count} characters",
    validationCodeError: "Verification code error",
    passwordValidation: "Password must be 4-16 characters long",
    terms: {
      heading: "Terms of Use",
      section1Title: "1. Acceptance of Terms",
      section1Body:
        "By accessing and using this website, you agree to comply with and be bound by the following terms and conditions. If you do not agree with these terms, please do not use this site.",
      section2Title: "2. Changes to Terms",
      section2Body:
        "We reserve the right to modify these terms at any time. Your continued use of the site following any changes signifies your acceptance of the new terms.",
      section3Title: "3. Use of the Site",
      section3Body1: "You must be at least 18 years old to use this site.",
      section3Body2: "You agree to use the site only for lawful purposes.",
      section3Body3:
        "You must not use the site in any way that causes, or is likely to cause, the site or access to it to be interrupted, damaged, or impaired in any way.",
      section4Title: "4. Account Registration",
      section4Body1: "You must provide accurate and complete information when creating an account.",
      section4Body2: "You are responsible for maintaining the confidentiality of your account details.",
      section4Body3: "You must notify us immediately of any unauthorized use of your account.",
      section5Title: "5. Privacy Policy",
      section5Body: "Your use of the site is also governed by our Privacy Policy, which can be found here.",
      section6Title: "6. Intellectual Property",
      section6Body:
        "All content on this site, including text, graphics, logos, and images, is the property of the site owner and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works from any content without our express written permission.",
      section7Title: "7. Limitation of Liability",
      section7Body:
        'The site and its content are provided "as is." We make no warranties, express or implied, regarding the site. We will not be liable for any damages arising from the use of or inability to use the site.',
      section8Title: "8. Termination",
      section8Body:
        "We reserve the right to terminate your access to the site at our sole discretion, without notice and without liability.",
      section9Title: "9. Governing Law",
      section9Body:
        "These terms are governed by and construed in accordance with the laws of [Your Country/State], without regard to its conflict of law principles.",
      section10Title: "10. Contact Information",
      section10Body:
        "If you have any questions about these Terms of Use, please contact us at [contact information]."
    }
  }
};
